module.exports = __webpack_public_path__ + "img/pro-5-gen-portrait-mask.a710254.png";